import { Pipe, PipeTransform } from "@angular/core";

interface SizeMapping {
  label: string;
  denominator: number;
  precision: number;
}

@Pipe({
    name: "fileSize",
    standalone: false
})
export class FileSizePipe implements PipeTransform {
  mappings: SizeMapping[] = [
    { label: "GB", denominator: 1073741824, precision: 2 },
    { label: "MB", denominator: 1048576, precision: 2 },
    { label: "KB", denominator: 1024, precision: 0 }
  ];

  transform(value: number, args?: any): any {
    if (value) {
      for (let map of this.mappings) {
        if (value > map.denominator) {
          return `${(value / map.denominator).toFixed(map.precision)} ${map.label}`;
        }
      }

      return `${value} bytes`;
    }

    return null;
  }
}
